var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeFees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.49,24.91v-7.55c-6.26,0-11.33,5.07-11.33,11.33s5.07,11.33,11.33,11.33v-7.55c-2.09,0-3.78-1.69-3.78-3.78s1.69-3.78,3.78-3.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5,75.09v7.55c6.26,0,11.33-5.07,11.33-11.33h-7.55c0,2.09-1.69,3.78-3.78,3.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.83,71.32c0-4.17-3.38-7.55-7.55-7.55h-7.56V28.68c0-6.26-5.07-11.33-11.33-11.33H19.49v7.55s0,0,0,0c2.09,0,3.78,1.69,3.78,3.78h0c0,2.09-1.69,3.78-3.78,3.78v7.55c1.33,0,2.59-.24,3.78-.66v31.96c0,6.26,5.07,11.33,11.33,11.33h45.9v-7.55h-35.23c.42-1.18.66-2.45.66-3.78h-7.55c0,2.09-1.69,3.78-3.78,3.78h0s0,0,0,0c-2.09,0-3.78-1.69-3.78-3.78h0V28.68h0c0-1.33-.24-2.59-.66-3.78h35.23c2.09,0,3.78,1.69,3.78,3.78v35.08h-23.24c-4.17,0-7.55,3.38-7.55,7.55h30.8s7.55,0,7.55,0h0s7.56,0,7.56,0h7.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeFees);
export default __webpack_public_path__ + "static/media/acae_fees.b0815113.svg";
export { ForwardRef as ReactComponent };